import { Helmet, HelmetProvider } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import { useMetaInfo } from '../../hooks/useMetaInfo';
import { useTranslation } from 'react-i18next';

const API_URL = import.meta.env.VITE_API_URL || 'http://0.0.0.0:8055';
const BASE_URL = 'https://methodfund.squarestudio.org'; 


const LANGUAGES = ['uk', 'en'];
const DEFAULT_LANGUAGE = 'uk';

const helmetContext = {};

const MetaHelmet = () => {
  const { data: metaInfo } = useMetaInfo();
  const location = useLocation();
  const { i18n } = useTranslation();

  const currentLanguage = i18n.language;

  if (!metaInfo) return null;

  const currentTranslation = metaInfo?.translations?.find(
    (t) => t.languages_code === currentLanguage
  );

  if (!currentTranslation) return null;

  const pathSegments = location.pathname.split('/').filter(Boolean);
  const firstSegment = pathSegments[0];
  const hasLangPrefix = LANGUAGES.includes(firstSegment);
  

  const pathWithoutLang = hasLangPrefix
    ? `/${pathSegments.slice(1).join('/')}`
    : location.pathname;
  

  const getAlternateUrl = (langCode: string) => {
    if (langCode === DEFAULT_LANGUAGE) {
      
      return `${BASE_URL}${pathWithoutLang}`;
    } else {
     
      return `${BASE_URL}/${langCode}${pathWithoutLang === '/' ? '' : pathWithoutLang}`;
    }
  };

  return (
    <HelmetProvider context={helmetContext}>
      <Helmet>
       
        <title>{currentTranslation.title}</title>
        <meta name="description" content={currentTranslation.description} />
        <meta name="keywords" content={currentTranslation.keywords} />
        <meta name="robots" content={currentTranslation.robots_content} />
        <html lang={currentLanguage} />

       
        <meta property="og:title" content={currentTranslation.og_title} />
        <meta property="og:description" content={currentTranslation.og_description} />
        {metaInfo.og_image && (
          <meta 
            property="og:image" 
            content={`${API_URL}/assets/${metaInfo.og_image}`} 
          />
        )}
        <meta property="og:url" content={`${BASE_URL}${location.pathname}`} />
        <meta property="og:type" content="website" />
        <meta property="og:locale" content={currentLanguage === 'en' ? 'en_US' : 'uk_UA'} />


        <link rel="canonical" href={getAlternateUrl(currentLanguage)} />
        
        {LANGUAGES.map((langCode) => (
          <link
            key={langCode}
            rel="alternate"
            hrefLang={langCode}
            href={getAlternateUrl(langCode)}
          />
        ))}
        
        <link 
          rel="alternate" 
          hrefLang="x-default" 
          href={getAlternateUrl(DEFAULT_LANGUAGE)} 
        />
      </Helmet>
    </HelmetProvider>
  );
};

export default MetaHelmet;